// Кадр между уроками: блоки нового урока ещё едут. Отдельный экран нужен,
// потому что пустой список неотличим от пройденного урока, а объявлять чужой
// урок пройденным — врать автору.
import { blockTheme, hsl } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export const PreviewLoading = () => {
  const m = useMessages(messages)
  return (
    <div
      className="flex h-full w-full items-center justify-center px-8 text-center"
      style={{ backgroundColor: hsl(blockTheme.quizCanvas) }}
    >
      <p className="text-sm" style={{ color: hsl(blockTheme.quizMuted) }}>
        {m.loading}
      </p>
    </div>
  )
}
